/** Short label for an estimator result, or null when this run did not size the issue. */
export function estimateLabel(structured: Record<string, unknown> | null | undefined): string | null {
  if (!structured) return null;
  const points = structured.storyPoints;
  const sla = structured.sla;
  if (typeof points !== "number" || typeof sla !== "string") return null;
  const due = typeof structured.dueAt === "string" ? formatSydney(structured.dueAt) : null;
  const duration = slaPhrase(sla);
  return due ? `${points} pts · ${duration} · due ${due}` : `${points} pts · ${duration}`;
}

function slaPhrase(sla: string): string {
  if (sla === "1h") return "1 hour";
  if (sla === "4h") return "4 hours";
  if (!sla.endsWith("d")) return sla;
  const days = Number(sla.slice(0, -1));
  return days === 1 ? "1 working day" : `${days} working days`;
}

function formatSydney(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return new Intl.DateTimeFormat("en-AU", {
    timeZone: "Australia/Sydney",
    weekday: "short",
    day: "numeric",
    month: "short",
    hour: "numeric",
    minute: "2-digit",
  }).format(date);
}
